<template>
  <div>
  <div class="h-toolbarBg">
    <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
    <div class='h-inputBox'>
      <ejs-textbox v-model='keyword' :placeholder='$t("Security.User.username")' @keyup.enter.native="filterAccount" maxLength='20'></ejs-textbox>
    </div>
  </div>
  <div class="h-scroll">
    <ejs-grid :dataSource="clientDataSource" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight">
      <e-columns>
        <e-column type="checkbox" width="50" textAlign="center"></e-column>
        <e-column field="id" :visible="false"></e-column>
        <e-column field="accountId" :visible="false"></e-column>
        <e-column field="accountName" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
        <e-column field="addresses" :headerText="$t('Security.client.addresses')" width="120" textAlign="Center"></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager
      ref="pager"
      :pageSize="pageSettings.pageSize"
      :pageCount="page.pageCount"
      :currentPage="page.pageNo"
      :totalRecordsCount="page.totalRecordsCount"
      @click="getDataSource"
    ></ejs-pager>
  </div>
  <CustomDialog
    ref="addAccIpDialog"
    v-bind:element="addDialog.element"
    v-bind:styles="addDialog.styles"
  >
    <template v-slot:dialog-content>
      <AccountOption ref="addAccIp" :baseType="add"></AccountOption>
    </template>
  </CustomDialog>
  <CustomDialog
    ref="modifyAccIpDialog"
    v-bind:element="editDialog.element"
    v-bind:styles="editDialog.styles"
  >
    <template v-slot:dialog-content>
      <AccountOption ref="modifyAccIp" :baseType="modify"></AccountOption>
    </template>
  </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from '../../common/CustomDialog';
import { EventBus } from "../../../plugins/eventBus";
import AccountOption from "./accountOption";

export default {
  name: "accountIpPage",
  components: {
    CustomDialog,
    AccountOption
  },
  data() {
    return {
      add: 'add',
      modify: 'modify',
      keyword: '',
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showModifyDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteClientRule },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid }
      ],
      clientDataSource: '',
      pageSettings: {
        pageSize: 15
      },
      page: {
        pageCount: 4,
        pageNo: 1,
        totalRecordsCount: 0
      },
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addAccIpDialog',
          buttonGroup: [
            {
              click: this.addDialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addClient,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Security.client.addClient')}`
        },
        styles: {
          width: '800px',
          height: '350px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'modifyAccIpDialog',
          title: `${this.$t('Security.client.editClient')}`,
          buttonGroup: [
            {
              click: this.modifyDialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.modifyClient,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ]
        },
        styles: {
          width: '800px',
          height: '350px',
          model: true,
          visible: false
        }
      },
      screenHeight: document.body.clientHeight - 275
    }
  },
  mounted() {
    this.getDataSource();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 275;
      })()
    }
  },
  methods: {
    getDataSource() {
      const url = '/lte/ems/client/queryAccountIP';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
          pageNo: this.page.pageNo,
          pageSize: this.pageSettings.pageSize,
          accountName: this.keyword

        } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        That.clientDataSource = result;
        That.page.totalRecordsCount = response.data.totalCount;
        That.$refs.grid.clearSelection()
      });
    },
    showAddDialog() {
      this.$refs.addAccIp.init();
      this.$refs.addAccIpDialog.show();
    },
    showModifyDialog() {
      let record = this.getRecord();
      if (record.length === 0) {
        this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.eventEmit('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.$refs.modifyAccIp.init(record[0].id, record[0].accountId);
      this.$refs.modifyAccIpDialog.show();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.eventEmit('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    addClient() {
      let validResult = this.$refs.addAccIp.validation();
      if (validResult) {
        const url = '/lte/ems/client/saveAccountIP';
        let param = this.$refs.addAccIp.getParam();
        let That = this;
        this.axios.post(url, param).then(response => {
          const result = response.data;
          if(result) {
            That.eventEmit('success', `${this.$t('Common.tips.success')}`);
            That.getDataSource();
          } else {
            That.eventEmit('error', `${this.$t('Common.tips.failure')}`);
          }
          That.addDialogHide();
        });
      }
    },
    modifyClient() {
      let validResult = this.$refs.modifyAccIp.validation();
      if (validResult) {
        const url = '/lte/ems/client/modifyAccountIP';
        let param = this.$refs.modifyAccIp.getParam();
        let That = this;
        this.axios.post(url, param).then(response => {
          const result = response.data;
          if(result) {
            That.eventEmit('success', `${this.$t('Common.tips.success')}`);
            That.getDataSource();
          } else {
            That.eventEmit('error', `${this.$t('Common.tips.failure')}`);
          }
          That.modifyDialogHide();
        });
      }
    },
    deleteClientRule() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const url = '/lte/ems/client/deleteAccountIP';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.id);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.eventEmit('success', `${this.$t('Common.tips.success')}`);
                That.getDataSource();
              } else {
                That.eventEmit('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },
    filterAccount() {
      this.getDataSource();
    },
    addDialogHide() {
      this.$refs.addAccIpDialog.clear();
      this.$refs.addAccIpDialog.close();
    },
    modifyDialogHide() {
      this.$refs.modifyAccIpDialog.clear();
      this.$refs.modifyAccIpDialog.close();
    },
    refreshGrid() {
      this.getDataSource();
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  }
}
</script>

<style scoped>

</style>
